import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col, Input, message, Icon, Divider, Select, Button, Modal } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import { CreateButton } from '../../components/AppButton'
import Table from './Table'
import Card from './Card'
import {
  fetchItems,
  changeTable,
  searchTable,
  editSearch,
  fetchGroups, fetchGroupSellers,
} from '../../actions/sellerList'
import { getWidth } from '../../shared/utils'
import './index.less'
import GroupsManagement from './GroupsManagement'

const { Search } = Input
const { Option } = Select
const pageTitle = 'Торговые сети'
const storeKey = 'sellerList'
const createPath = '/admin/sellers/create'
const editPath = '/admin/sellers/edit'

const QUICK_FILTER_WITHOUT_BLOCKS = 'without_blocks'
const QUICK_FILTER_BALANCE_LESS_100 = 'balance_less_100'

class ItemList extends React.Component {
    state = {
      width: getWidth(),
      visibleModal: false,
      activeGroup: this.props.activeGroup || 'all',
      activeQuickFilters: this.props.activeQuickFilters || [],
      groupModalType: 'create',
    }

    constructor(props, context) {
      super(props, context)
      this.handleCreateButtonOnClick = this.handleCreateButtonOnClick.bind(this)
      this.handleTableOnChange = this.handleTableOnChange.bind(this)
      this.handleSearchOnChange = this.handleSearchOnChange.bind(this)
      this.handleSearchOnClick = this.handleSearchOnClick.bind(this)
      this.handleSearchOnCancel = this.handleSearchOnCancel.bind(this)
      this.hadleGroupsSelect = this.hadleGroupsSelect.bind(this)
      this.handleQuickFiltersSelect = this.handleQuickFiltersSelect.bind(this)
    }

    updateDimensions = () => {
      this.setState({ width: getWidth() })
    }

    hadleGroupsSelect(value) {
      if (value === this.state.activeGroup) return
      this.setState({
        activeGroup: value,
      }, async () => {
        await this.props.changeTable({
          pagination: {
            ...this.props.pagination,
            current: 1,
          },
          filters: this.props.filters,
          sorter: this.props.sorter,
          activeGroup: value,
        })
        this.fetchItems()
      })
    }

    handleQuickFiltersSelect(value) {
      this.setState({
        activeQuickFilters: value,
      }, async () => {
        await this.props.changeTable({
          pagination: {
            ...this.props.pagination,
            current: 1,
          },
          filters: this.props.filters,
          sorter: this.props.sorter,
          activeQuickFilters: value,
        })
        this.fetchItems()
      })
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions)
      this.fetchItems()
      this.fetchGroups()
      const { isSearching } = this.props
      !isSearching && this.props.editSearch({ search: null })
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions)
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.isFetchItemsLoading && nextProps.fetchItemsError) {
        message.error(nextProps.fetchItemsError)
      }
    }

    fetchItems() {
      const {
        pagination = {},
        sorter = {},
        filters = {},
        search,
        isSearching,
      } = this.props
      this.props.fetchItems({
        current: pagination.current,
        pageSize: pagination.pageSize,
        sort: sorter.columnKey,
        filters: JSON.stringify(filters),
        order: sorter.order,
        search: (isSearching && search) || null,
        group: this.state.activeGroup !== 'all' ? Number(this.state.activeGroup) : null,
        without_blocks: this.state.activeQuickFilters.includes(QUICK_FILTER_WITHOUT_BLOCKS) ? 1 : 0,
        balance_less_100: this.state.activeQuickFilters.includes(QUICK_FILTER_BALANCE_LESS_100) ? 1 : 0,
      })
    }

    /**
     * Get sellers by current group.
     * @param selectedGroupId {string} Selected group identification.
     * @returns {Promise<void>}
     */
    async fetchGroupSellers({ selectedGroupId }) {
      this.props.fetchGroupSellers({
        idnum: selectedGroupId,
      })
    }

    /**
     * Fetch groups of sellers.
     */
    async fetchGroups() {
      this.props.fetchGroups()
    }

    handleCreateButtonOnClick(e) {
      e.preventDefault()
      this.props.history.push(createPath)
    }

    async handleTableOnChange(pagination, filters, sorter) {
      // console.log(filters, sorter)
      const {
        columnKey,
        field,
        order,
      } = sorter

      await this.props.changeTable({
        pagination,
        filters,
        sorter: {
          columnKey,
          field,
          order,
        },
      })
      this.fetchItems()
    }

    handleSearchOnChange(e) {
      e.preventDefault()
      const search = e.target.value
      this.props.editSearch({ search })
      if (!search) {
        this.props.searchTable({ isSearching: false })
      }
    }

    async handleSearchOnClick() {
      await this.props.searchTable({ isSearching: true })
      await this.props.changeTable({})
      this.fetchItems()
    }

    async handleSearchOnCancel(e) {
      e.preventDefault()
      await this.props.editSearch({ search: null })
      await this.props.searchTable({ isSearching: false })
      await this.props.changeTable({})
      this.fetchItems()
    }

    render() {
      const { width } = this.state
      return (
        <div>
          <AdminLayout>
            <SectionHeader>
              <SectionHeaderTemplate
                breadcrumbRoutes={[{
                                path: '/admin',
                                title: 'Главная',
                            }, { title: pageTitle }]}
                title={pageTitle}
              />
            </SectionHeader>
            <SectionContent>
              <Row
                type='flex'
                justify='space-between'
                style={{ marginBottom: '24px' }}
                className='seller-list-toolbar'
              >
                <Col className='search-top'>
                  <CreateButton
                    onClick={this.handleCreateButtonOnClick}
                  />
                </Col>

                <Col className='search-top'>
                  <Row
                    type='flex'
                    justify='space-between'
                    gutter={12}
                    className='seller-list-toolbar-inner'
                  >
                    <Col>
                      <Button
                        disabled={this.state.activeGroup === 'all' || this.props.isFetchItemsLoading}
                        onClick={() => {
                                                this.setState({
                                                    visibleModal: true,
                                                    groupModalType: 'edit',
                                                })
                                            }}
                        style={{
                                                marginRight: 10,
                                            }}
                        type='primary'
                        size='small'
                        icon='setting'
                      />
                      <Select
                        style={{ width: 240 }}
                        value={this.state.activeGroup}
                        onChange={this.hadleGroupsSelect}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        dropdownRender={menu => (
                          <div>
                            <div
                              style={{
                                                            padding: '4px 8px',
                                                            cursor: 'pointer',
                                                        }}
                              onMouseDown={e => e.preventDefault()}
                              onClick={() => {
                                                            this.setState({
                                                                visibleModal: true,
                                                                groupModalType: 'create',
                                                            })
                                                        }}
                            >
                              Добавить группу <Icon type='plus' />
                            </div>
                            <Divider style={{ margin: '4px 0' }} />
                            {menu}
                          </div>
                                            )}
                      >
                        <Select.Option value='all' key='all'>Все</Select.Option>
                        {this.props.sellerGroups && this.props.sellerGroups.map(item => (
                          <Select.Option value={item.id} key={item.id}>
                            {item.name}
                          </Select.Option>
                                            ))}
                      </Select>
                    </Col>
                    <Col>
                      <Select
                        mode='multiple'
                        allowClear
                        placeholder='Фильтры'
                        style={{ width: 260 }}
                        value={this.state.activeQuickFilters}
                        onChange={this.handleQuickFiltersSelect}
                        disabled={this.props.isFetchItemsLoading}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                      >
                        <Option value={QUICK_FILTER_WITHOUT_BLOCKS}>Без блокировок</Option>
                        <Option value={QUICK_FILTER_BALANCE_LESS_100}>Баланс меньше 100 ₽</Option>
                      </Select>
                    </Col>
                    <Col>
                      <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                      >
                        <Search
                          onChange={this.handleSearchOnChange}
                          onSearch={this.handleSearchOnClick}
                          value={this.props.search}
                          enterButton
                        />
                        {
                                                this.props.isSearching &&
                                                <a
                                                  href=''
                                                  onClick={this.handleSearchOnCancel}
                                                  style={{
                                                        lineHeight: 1.5,
                                                        marginLeft: '12px',
                                                    }}
                                                >
                                                  Отмена
                                                </a>
                                            }
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {width > 1200 ?
                <Table
                  loading={this.props.isFetchItemsLoading}
                  dataSource={this.props.items || []}
                  pagination={this.props.pagination}
                  filters={this.props.filters}
                  sorter={this.props.sorter}
                  onChange={this.handleTableOnChange}
                  editPath={editPath}
                />
                            :
                <Card
                  loading={this.props.isFetchItemsLoading}
                  width={width}
                  dataSource={this.props.items || []}
                  pagination={this.props.pagination}
                  filters={this.props.filters}
                  sorter={this.props.sorter}
                  onChange={this.handleTableOnChange}
                  editPath={editPath}
                />
                        }
            </SectionContent>
          </AdminLayout>
          <Modal
            title='Управление группами'
            width={800}
            visible={this.state.visibleModal}
            footer={[]}
            onCancel={() => this.setState({
                        visibleModal: false,
                    })
          }
          >
            <GroupsManagement
              groupName={this.state.groupModalType === 'edit' && this.state.activeGroup !== 'all' ? this.props.sellerGroups.find(item => item.id === this.state.activeGroup).name : ''}
              groupSellers={this.state.groupModalType === 'edit' ? this.props.items : []}
              activeGroup={this.state.activeGroup}
              type={this.state.groupModalType}
            />
          </Modal>
        </div>
      )
    }
}

const mapStateToProps = (state) => {
  const {
    items=[],
    total,
    isFetchItemsLoading,
    pagination = {},
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
    sellerGroups,
    activeGroup,
    activeQuickFilters,
  } = state[storeKey]
  !pagination.pageSize && (pagination.pageSize = 12)
  !pagination.current && (pagination.current = 1)
  return {
    items,
    total,
    isFetchItemsLoading,
    pagination,
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
    sellerGroups,
    activeGroup,
    activeQuickFilters,
  }
}

const mapDispatchToProps = dispatch => ({
  fetchItems: params => dispatch(fetchItems(params)),
  changeTable: params => dispatch(changeTable(params)),
  editSearch: search => dispatch(editSearch(search)),
  searchTable: search => dispatch(searchTable(search)),
  fetchGroups: () => dispatch(fetchGroups()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemList))



// WEBPACK FOOTER //
// src/containers/SellerList/index.jsx